"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Send = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var Send = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Send, _super);
    function Send() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '发送验证码接口';
        _this.code = '101067';
        _this.desc = '发送验证码接口';
        _this.requestParams = new dynamicCode_1.SendRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Send;
}(service_1.BaseService));
exports.Send = Send;
//# sourceMappingURL=send.js.map